import countries from "./countries.component";
import countriesUrls from "./countries.urls";
import CountriesTransforms from "./countries.transforms";

const countriesModule = angular
  .module("app.components.countries", [])
  .component("countriesPage", countries)
  .service("CountriesTransforms", CountriesTransforms)
  .config(countriesUrls);

export default countriesModule;



// WEBPACK FOOTER //
// ./src/pages/countries/countries.module.js